import { SearchInput } from 'src/uikit/SearchInput';

import s from './Search.module.scss';

interface SearchProps {
  value: string;
  setValue: (newSearch: string) => void;
}

export function Search({ value, setValue }: SearchProps) {
  return (
    <div className={s.root} data-qa="search_wrapper">
      <SearchInput className={s.field} value={value} onValueChange={setValue} />
    </div>
  );
}
